import { Component, OnInit, Sanitizer, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Flow } from '../obj/Flow';
import { FlowManagementService } from '../services/flow-management.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { State, process } from '@progress/kendo-data-query';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { DeployItem, Plan, DeployReplaceItem } from '../obj/DeployItem';
import { StorageRouterService } from '../services/storage-router.service';
import { Settings } from '../flows/settings';
import { ENV_SCAN_STALE_MS } from '../services/env-scan.util';
//import { AnalyticsService } from '../services/analytics.service';
import { FlowEvent, FlowEventService } from '../services/flow-event.service';
import { PowerApp } from '../obj/PowerApp';
import { PowerBase } from '../obj/PowerBase';
import { ApplicationInsightsService } from '../services/application-insights.service';
// import { TooltipDirective } from '@progress/kendo-angular-tooltip';
// import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';

@Component({
    selector: 'app-deploy',
    templateUrl: './deploy.component.html',
    styleUrls: ['./deploy.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class DeployComponent implements OnInit {

  constructor(
    private flowManagementService: FlowManagementService,
    private flowEventService: FlowEventService,
    private storageDexieService: StorageRouterService,
    private sanitizer: DomSanitizer,
    //private analytics: AnalyticsService,
    private appInsights: ApplicationInsightsService,
    private formBuilder: UntypedFormBuilder,
    private router: Router) {

  }

  apiRoot: string = "https://flow.microsoft.com";

  sourceObjects: PowerBase[] = [];
  sourceConnections: any[] = [];
  destinationObjects: PowerBase[] = [];
  destinationConnections: any[] = [];
  viewSource: PowerBase[] = this.sourceObjects.slice();
  viewDestination: PowerBase[] = this.destinationObjects.slice();

  viewDestinationConnections: any[] = this.destinationConnections.slice();
  groupDestinationConnections: any[];

  sourceApps: PowerApp[] = [];

  viewURLs: any[];
  sourceLoading = false;
  sourceEnvironment: string;
  destinationLoading = false;
  destinationEnvironment: string;

  public environments: any[];


  //sourceFlow: Flow;
  //destinationName: string;
  loading: boolean = false;
  //raw: any;
  rawDestination: any;

  public plans: any[] = [];
  selectedPlan: string = '';

  public deployPlan: Plan = new Plan();
  public gridState: State = {};
  public viewReplace : GridDataResult = process([], this.gridState);

  public results = [];

  public selection: number[] = [];
  // @ViewChild(TooltipDirective)
  // public tooltipDir: TooltipDirective;

  // @ViewChild('selectedPlanAnchor') public selectedPlanAnchor: ComboBoxComponent;

  // get plans() {
  //   return this._plans.map(p=>p);
  // }

  ngOnInit() {
    this.refresh();

    this.flowEventService.planUpdated$.subscribe(()=>{

      this.loading = true;
      let p1 = this.flowManagementService.getPlans();
      //let p2 = this.storageDexieService.getPlans();

      Promise.all([p1/*,p2*/]).then(([plans/*, storage*/])=>{

        // let plans = (server && server.length) ? server : storage;
        // debugger;

        if (plans == null || plans.length == 0) {
          this.loading = false;
          return;
        }

        if (this.plans == null || JSON.stringify(plans) != JSON.stringify(this.plans)){
          this.plans = plans
        }

      }, err=> {
      }).then(()=>{
        this.loading = false;
      });

    });

    this.storageDexieService.putConfig(Settings.SETTING_LASTROUTE,{
      key: Settings.SETTING_LASTROUTE,
      'value': '/migrate'
    });

  }

  async refresh(source = true, destination = true) {
    this.loading = true;
    var promises = [];

    let pEnvs = this.flowManagementService.getEnvironments().toPromise();
    pEnvs.then(res=>{
      //debugger
      this.environments = res.value.map(env=>{
        return {
          'name': env.name,
          'displayName': env.properties.displayName
        }
      });
    });
    promises.push(pEnvs);

    /*
    let pFlows = this.flowManagementService.getFlows(this.flowManagementService.currentEnvironment, false, false, false, false);
    pFlows.then(flows => {
      this.source = flows;
      this.viewSource = this.source.slice();
      this.viewDestination = this.source.slice();
    });
    */
   if (this.deployPlan) {
     if (source) {
      let pS = this.environmentSourceChange();
      promises.push(pS);
     }
     if (destination) {
      let pD = this.environmentDestinationChange();
      promises.push(pD);
     }
   }
   /*
    let pConnections = this.flowManagementService.getConnections(this.flowManagementService.currentEnvironment);
    pConnections.then(connections=>{

    });
    promises.push(pConnections);
    */
    let pServer = this.flowManagementService.getPlans().then(plans=>{
      return plans;
    }, ()=>{
      return null;
    });
    promises.push(pServer);
    // let pPlans = this.storageDexieService.getPlans().then(plans=>{
    //   return plans;
    // }, ()=>{
    //   return null;
    // });
    // promises.push(pPlans);

    Promise.all([pServer/*,pPlans*/]).then(([plans/*, storage*/])=>{

      //let plans = (server && server.plans && server.plans.length) ? server.plans : storage;
      // if (plans && storage) {
      //   storage.forEach((item:Plan)=>{
      //     let one = plans.find((i:Plan)=>i.name == item.name);
      //     if (one == null) {
      //       plans.push(item);
      //     }
      //   })
      // }
      this.plans = plans;
    });

    Promise.all(promises).then(()=>{

    }, ()=> {

    }).then(()=>{
      //finally
      this.loading = false;
    });
  }

  getSafeUrl(url): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  public filterChangeSource(filter: any): void {
    this.viewSource = this.sourceObjects.filter((s) => {
      return s.displayName.toLowerCase().indexOf(filter.toLowerCase()) !== -1;
    });
  }
  public filterChangeDestination(filter: any): void {
    this.viewDestination = this.destinationObjects.filter((s) => {
      return s.displayName.toLowerCase().indexOf(filter.toLowerCase()) !== -1;
    });
  }

  public filterChangeDestinationConnection(filter: any, dataItem: any): void {
    //debugger;
    this.viewDestinationConnections = this.destinationConnections.filter(c=>{
      return true;
    });
  }

  public environmentSourceChange(force=false):Promise<any> {
    if (!this.deployPlan.environmentSource) {
      return Promise.resolve();
    }
    if (!force && this.sourceEnvironment == this.deployPlan.environmentSource) {
      return Promise.resolve();
    }

    this.sourceLoading = true;
    let promises = [];
    let pFlows = this.getFlowsRespectingScanStale(this.deployPlan.environmentSource);
    pFlows.then(flows => {
      //debugger
    }, reason=> {

    });
    promises.push(pFlows);

    let pConnections = this.flowManagementService.getConnectionsUser(this.deployPlan.environmentSource);
    pConnections.then(connections=>{
      //debugger
      this.sourceConnections = connections.filter( (c:any)=>{
        return c.apiId != "/providers/Microsoft.PowerApps/apis/shared_logicflows"
      }).map(c=>{
        return {
          apiId: c.apiId,
          displayName: c.displayName,
          name: c.name,
          status: c.status,
          iconUri: c.iconUri
        }
      }).sort((a,b)=> a.displayName.localeCompare(b.displayName));
    });
    promises.push(pConnections);

    let pApps = this.flowManagementService.getApps(this.deployPlan.environmentSource, false);
    pApps.then(apps => {

//      this.sourceApps = apps;
    })
    promises.push(pApps);

    return Promise.all(promises).then(([flows, connections, apps])=>{

      this.sourceEnvironment = this.deployPlan.environmentSource;
      let objects = [].concat(flows, apps);

      this.sourceObjects = objects;
      this.viewSource = this.sourceObjects.slice();


    }, ()=> {

    }).then(()=>{
      this.sourceLoading = false;
    })
    //return pFlows;
  }

  public environmentDestinationChange(force=false): Promise<any> {

    if (!this.deployPlan.environmentDestination) {
      return Promise.resolve();
    }
    if (!force && this.destinationEnvironment == this.deployPlan.environmentDestination) {
      return Promise.resolve();
    }

    this.destinationLoading = true;
    let promises = [];
    let pFlows = this.getFlowsRespectingScanStale(this.deployPlan.environmentDestination);
    pFlows.then(flows => {
      this.destinationObjects = flows.sort((a:Flow,b:Flow)=> a.displayName.localeCompare(b.displayName));
      this.viewDestination = this.destinationObjects.slice();
      //debugger
    }, reason => {

    });
    promises.push(pFlows);

    let pConnections = this.flowManagementService.getConnectionsUser(this.deployPlan.environmentDestination);
    pConnections.then(connections=>{
      //debugger
      this.destinationConnections = connections.filter( (c:any)=>{
        return c.apiId != "/providers/Microsoft.PowerApps/apis/shared_logicflows"
      }).map(c=>{
        return {
          apiId: c.apiId,
          displayName: c.displayName,
          name: c.name,
          status: c.status,
          iconUri: c.iconUri
        }
      }).sort((a,b)=> a.displayName.localeCompare(b.displayName));
      this.viewDestinationConnections = this.destinationConnections.slice();
    });
    promises.push(pConnections);

    let pApps = this.flowManagementService.getApps(this.deployPlan.environmentSource, false);
    pApps.then(apps => {

//      this.sourceApps = apps;
    })
    promises.push(pApps);

    return Promise.all(promises).then(([flows, connections, apps])=>{


      let objects = [].concat(flows, apps);
      objects = objects.sort((a:PowerBase,b:PowerBase)=> a.displayName.localeCompare(b.displayName));

      this.destinationEnvironment = this.deployPlan.environmentDestination;
      this.destinationObjects = objects;
      this.viewSource = this.destinationObjects.slice();


    }, ()=> {

    }).then(()=>{
      this.destinationLoading = false;
    })

    //return pFlows;
  }

  public planChange(value) {

    if (!this.selectedPlan) {
      return;
    }

    let plan = this.plans.find(p=>p.name == this.selectedPlan);

    if (!plan) {
      return;
    }

    if (this.deployPlan != plan) {
      this.deployPlan = plan;

      let promises = [];
      if (this.deployPlan.environmentDestination) {
        let p = this.environmentDestinationChange();
        promises.push(p);
      }
      if (this.deployPlan.environmentSource) {
        if (this.deployPlan.environmentSource == this.deployPlan.environmentDestination) {
          this.sourceLoading = true;
          Promise.all(promises).then(()=>{

            this.sourceObjects = this.destinationObjects;
            this.sourceConnections = this.destinationConnections.slice();
            this.viewSource = this.sourceObjects.slice();
            this.sourceLoading = false;

          });
        }
        else {
          this.environmentSourceChange();
        }
      }
    }
  }

  public sourceChange(value: any): void {
    // if (!this.sourceFlow) {
    //   return;
    // }

  }

  checkFlow(item: DeployItem, flowSource: Flow, flowDestination: Flow) {

    let promises = [];
    if (flowSource.type == "flow") {
      let pFlowSource = this.flowManagementService.getFlow(flowSource.environment, flowSource.flowName).toPromise();
      promises.push(pFlowSource);
    }
    if (flowSource.type == "powerapp") {
      let pAppSource = this.flowManagementService.getApp(flowSource.environment, flowSource.name);
      promises.push(pAppSource);
    }

    // if (flowDestination) {
    //   let pFlowDestination = this.flowManagementService.getFlow(flowDestination.environment, flowDestination.flowName).toPromise();
    //   promises.push(pFlowDestination);
    // }

    Promise.all(promises).then( ([rawSource /*, rawDestination*/])=>{

      // flow
      // item.rawSource = flow;

      let connections = this.connections(rawSource);
      let replaces = []
      replaces.push( ...connections.map(c=> {

        let s, d, n;
        let cf = this.getConnectionReference(rawSource, c);
        let p = cf.id;
        if (flowSource.type == "flow") {
          n = c;
          s = cf.connectionName;
          d = cf.connectionName;
        }
        if (flowSource.type == "powerapp") {
          n = p.replace('/providers/microsoft.powerapps/apis/', '');
          s = cf.connectionName;
          d = cf.connectionName;
        }

        return Object.assign(new DeployReplaceItem(), {
          "type": "Connection",
          "name": n,
          "source": s,
          "destination": d,
          "path": [ p ]
        })
      }));

      let links = this.links(rawSource)
      replaces.push( ...links.map(l=> {
        return Object.assign(new DeployReplaceItem(), {
          "type": "Text",
          "name": "URL",
          "source": l.value,
          "destination": l.value,
          "path": l.path
        });
      }));

      let guids = this.guids(rawSource);
      replaces.push( ...guids.map(v=> {
        return Object.assign(new DeployReplaceItem(),{
          "type": "Text",
          "name": "GUID",
          "source": v.value,
          "destination": v.value,
          "path": v.path
        });
      }));

      let triggers = this.triggers(rawSource);
      replaces.push( ...triggers.map(v=> {
        return Object.assign(new DeployReplaceItem(),{
          "type": "Trigger",
          "name": v.name,
          "source": v.value,
          "destination": v.value,
          "description": "",
          "path": v.path
        });
      }));

      let variables = this.variables(rawSource);
      replaces.push( ...variables.map(v=> {
        return Object.assign(new DeployReplaceItem(),{
          "type": "Variable",
          "name": v.name,
          "source": v.value,
          "destination": v.value,
          "path": v.path
        });
      }));

      replaces.forEach(r=>{

        let rule = item.replacements.find(i=>{
          return (
            (i.type == r.type && !i.name && !r.name && i.source == r.source) ||
            (i.type == r.type && i.type != "Trigger" && i.name == r.name && i.source == r.source ) ||
            (i.type == r.type && i.type == "Trigger" && i.source == r.source)
            );
        });

        if (rule == null) {
          item.replacements.push(r);
        }

      });

      if (item.replacements.find(r=>r.type == "DisplayName" )==null){
        item.replacements.push(Object.assign(new DeployReplaceItem(),{
          "type": "DisplayName",
          "name": "",
          "source": flowSource.displayName,
          "destination": flowDestination? flowDestination.displayName : item.flowDestination,
          "path": ["properties","displayName"]
        }))
      }

      if (item.replacements.find(r=>r.type == "State" )==null){
        item.replacements.push(Object.assign(new DeployReplaceItem(),{
          "type": "State",
          "name": "",
          "source": flowSource.flowState,
          "destination": "Default",
          "path": ["properties","state"]
        }))
      }

      if (item.flowSource == item.flowDestination) {
        if (item.replacements.find(r=>r.type == "Override" )==null){
          item.replacements.push(Object.assign(new DeployReplaceItem(),{
            "type": "Override",
            "name": "",
            "source": "",
            "destination": "Skip",
            "path": ["properties","override"]
          }))
        }
      }


      //this.viewReplace = process(replaces, this.gridState);


    });

  }

  public getConnectionReference(raw: any, name: string): any {
    let connection = null;
    try {
      connection = raw.properties.connectionReferences[name]
      return connection;
    }
    catch {

    }
    return null;
  }

  public destinationChange(value: any): void {

    // if (!this.destinationName) {
    //   return;
    // }
    // if (!this.destinationFlow){
    //   return;
    // }

    // this.flowManagementService.getFlow(this.destinationFlow.environment, this.destinationFlow.flowName).toPromise().then(flow=>{

    //   // flow
    //   this.rawDestination = flow;

    // });

  }


  connections(raw) : string[] {

    if (!raw || !raw.properties) {
      return [];
    }

    return Object.keys(raw.properties.connectionReferences);
  }

  variables(raw) : any[] {

    if (!raw || !raw.properties) {
      return [];
    }

    let variables = [];
    let visitor = (key, value, path)=>{

      if (value instanceof Object &&
        'type' in value &&
        value.type == "InitializeVariable" &&
        value.inputs &&
        value.inputs.variables) {
        // found variable.
        variables.push(...value.inputs.variables.map(v=>{
          return {
            "name": v.name,
            "value": JSON.stringify(v.value),
            "path": [...path, key]
          }
        }));
      }
    }
    this.visit(raw.properties.definition, ['properties', 'definition'], visitor);
    return variables;
  }

  triggers(raw) : any[] {
    if (!raw || !raw.properties) {
      return [];
    }

    let triggers = [];
    let visitor = (key, value, path)=>{

      if (key == "triggers" && value instanceof Object) {

        let names = Object.keys(value);
        // may have multiple triggers one day, for now only 1

        names.forEach(name => {
          if ('inputs' in value[name]) {
            let triggerInputs = value[name]['inputs'];
            let triggerInputsProps = Object.keys(triggerInputs).filter(k=>['host','method','authentication'].find(match=> match==k) == null);

            triggerInputsProps.filter(t=>{
              let v = triggerInputs[t];
              return (typeof(v) == "string");
            }).forEach(t=>{
              let v = triggerInputs[t];

              let re = /(encodeURIComponent\('(.*?)'\))/gi;
              let m = null;
              do {
                m = re.exec(v);
                if (m) {

                  let value = m[2];

                  if (/(https?:\/\/.*?)(['"]|$)/gi.test(value)) {
                    // is URL
                  }
                  else if (/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/gi.test(value)) {
                    // is GUID
                  }
                  else {
                    triggers.push({
                      "name": t,
                      "value": m[2],
                      "path": [...path, "triggers", name, "inputs", t]
                    });
                  }
                }
              }
              while(m);
            });

          }
        })

      }
    }
    this.visit(raw.properties.definition, ['properties', 'definition'], visitor);
    return triggers;
  }

  links(raw): any[] {
    if (!raw || !raw.properties) {
      return [];
    }

    let links = [];
    let visitor = (key, value, path: string[])=>{
      if (typeof(value) == "string") {
        let m = /(https?:\/\/.*?)(['"]|$)/gi.exec(value);
        if (m) {

          // if (path.join('.').indexOf('.inputs.variables.')) {
          //   return;
          // }

          links.push({
            "name": key,
            "value": m[1],
            "path": [...path, key]
          })
        }
      }
    }
    this.visit(raw.properties.definition, ['properties', 'definition'], visitor);
    return links;
  }

  visit(definition: any, path: string[], visitor: (key: string, value: any, path: string[])=>void) {

    if (definition == null) {
      return;
    }

    for(const [key, value] of Object.entries(definition) as [string,any]) {
      if (key == "$schema") {
        continue;
      }
      visitor(key, value, path);
      if (value instanceof Object){
        this.visit(value, [...path, key], visitor);
        // if (more && more.length) {
        //   result.push(...more);
        // }
        continue;
      }
    }

  }

  guids(raw): any[] {
    if (!raw || !raw.properties) {
      return [];
    }

    let guids = [];
    let visitor = (key, value, path)=>{
      if (key == "operationMetadataId") {
        return;
      }
      if (typeof(value) == "string") {
        let m = /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/gi.exec(value);
        if ( m ){
          guids.push({
            "name": key,
            "value": m[0],
            "path": [...path, key]
          })
        }
      }
    }
    this.visit(raw.properties.definition, ['properties', 'definition'], visitor);
    return guids;
  }


  // get destinationFlow(): Flow {

  //   if (!this.source) {
  //     return null;
  //   }

  //   let arr = this.source.filter(f=>f.flowName == this.destinationName);

  //   if (arr.length > 0){
  //     return arr[0];
  //   }
  //   return null;
  // }

  wizard(item: DeployItem) {

    let flowSource = this.getFlow(item.flowSource) as Flow;
    let flowDestination = this.getDestinationFlow(item.flowDestination) as Flow;

    //if (flowSource.type == "flow") {
    this.checkFlow(item, flowSource, flowDestination);
    //}
  }

  deploy(selection = false) {

    let promises = [];
    let needPostRefresh = false;

    this.results = [];

    if (selection) {
      this.results.push(`starting... "${this.deployPlan.name}" ${this.selection.length} selected flow(s).`);
    }
    else {
      this.results.push(`starting... "${this.deployPlan.name}" ${this.deployPlan.items.length} flow(s).`);
    }

    //this.analytics.send("migrate", `run-${this.deployPlan.items.length}`);
    //this.appInsights.logPageView(`migrate: run-${this.deployPlan.items.length}`)
    this.appInsights.trackEvent(`migrate`, { "runs": this.deployPlan.items.length });

    this.deployPlan.items.forEach((item, index)=>{

      if (selection == true) {
        if (this.selection.indexOf(index) == -1) {
          // not found in selection - skip this row
          return;
        }
      }

      let replacementOverride = item.replacements.find(r=>r.type == 'Override');

      let sourceFlow = this.sourceObjects.find(f => f.name == item.flowSource) as Flow;

      if (replacementOverride && replacementOverride.destination == "Force") {
        // do nothing
      }
      else if (item.flowSource == item.flowDestination) {
        // don't overwrite yourself
        this.results.push(`skipped ${(sourceFlow.type == "flow"? "Flow": "PowerApp")} (${item.flowDestination}).  reason: (source and destination are the same item and no Override -Force)`);
        return;
      }

      let destinationFlow = this.destinationObjects.find(f => f.name == item.flowDestination) as Flow;

      let isNew = (destinationFlow == null);


      if (sourceFlow.type == "flow") {
        // duplicate
        let p = this.flowManagementService.getFlow(this.deployPlan.environmentSource, sourceFlow.flowName).toPromise().then(flowSource => {

          // ignore replacements where source and destination is the same
          // don't need to do anything
          let replacements = item.replacements.filter(r=>{
            return (
                r.type == 'DisplayName' ||
                r.type == 'State' ||
                (r.source && r.source != r.destination)
              );
          });

          let connectionReferences = flowSource.properties.connectionReferences;

          Object.keys(connectionReferences).forEach(ref=>{

            // for each connection ref.  look for connection string replacement.
            let rule = replacements.find(r=>r.type=="Connection" && r.name == ref);
            if (rule) {
              if (rule.source == connectionReferences[ref].connectionName) {

                let destination = this.destinationConnections.find(c=>c.name == rule.destination);
                if (destination != null) {
                  connectionReferences[ref] = {
                    'connectionName': rule.destination,
                    'id': `${destination.apiId}`
                  }

                }
                else {
                  connectionReferences[ref] = {
                    'connectionName': rule.destination,
                    'id': `${connectionReferences[ref].id}`
                  }
                }

              }
            }
          });

          // for each definition segment, look for string replacement.
          let definition = flowSource.properties.definition;

          this.visit(definition, [], (key,value, path)=>{

            // replace text
            if (value instanceof Object) {
              for(const [k1, v1] of Object.entries(value) as [string,any]) {

                // only after string v1
                if (typeof(v1) != "string") {
                  continue;
                }

                let rules = replacements.filter(r=> v1.indexOf(r.source) > -1 && r.type != 'DisplayName' && r.type != 'State');
                if (rules.length > 0) {
                  rules.forEach(rule=>{
                    value[k1] = value[k1].replace(rule.source, rule.destination);
                  })
                }
              }

              if ('type' in value && value.type == "InitializeVariable" && 'inputs' in value && 'variables' in value.inputs) {

                // look for inputs.variables
                value.inputs.variables.forEach(variable=>{

                  let rule = replacements.find(r=> r.type == "Variable" && r.name == variable.name);
                  if (rule != null) {
                    try {
                      variable.value = JSON.parse(rule.destination);
                    }
                    catch {
                      variable.value = rule.destination;
                    }
                  }
                })
              }
            }
            // replace variable

          });

          let replacementDisplayName = replacements.find(r=>r.type == 'DisplayName');
          let replacementState = replacements.find(r=>r.type == 'State');

          let state = "Stopped";
          if (isNew) {
            let newDisplayName = item.flowDestination;
            if (replacementDisplayName && replacementDisplayName.destination){
              newDisplayName = replacementDisplayName.destination;
            }
            if (replacementState && replacementState.destination && replacementState.destination != 'Default'){
              state = replacementState.destination;
            }

            var flowData = {
              "properties": {
                "definition": definition,
                "connectionReferences": connectionReferences,
                "displayName": newDisplayName, //flowSource.properties.displayName + " Copy",
                "templateName": flowSource.properties.templateName,
                "environment": {
                    "name": this.deployPlan.environmentDestination
                },
                "state": state,
              }
            };
            return this.flowManagementService.createFlow(this.deployPlan.environmentDestination, flowData).toPromise().then(flowResult => {
              // save flowName to deployItem
              item.flowDestination = flowResult.name;

              this.results.push(`created Flow "${newDisplayName}" (${item.flowDestination}).  state: ${state}.  (new Flows are always stopped)`);
              needPostRefresh = true;

            }, (reason)=> {
              this.results.push(`create Flow failed "${newDisplayName}".  reason: ${JSON.stringify(reason.error)}.`);

            });
          }
          else {
            let p1 = this.flowManagementService.getFlow(destinationFlow.environment, destinationFlow.flowName).toPromise().then(flowDestination => {

              let newDisplayName = destinationFlow.displayName;
              if (replacementDisplayName && replacementDisplayName.destination){
                newDisplayName = replacementDisplayName.destination;
              }

              state = flowDestination.properties.state;
              if (replacementState && replacementState.destination && replacementState.destination != 'Default'){
                state = replacementState.destination;
              }

              // overwrite
              var flowData = {
                "properties": {
                  "definition": definition,
                  "connectionReferences": connectionReferences,
                  "displayName": newDisplayName, //flowSource.properties.displayName + " Copy",
                  "templateName": flowSource.properties.templateName,
                  "environment": {
                      "name": destinationFlow.environment
                  },
                  "state": state,
                }
              };
              return this.flowManagementService.updateFlow(destinationFlow.environment, destinationFlow.flowName, flowData).toPromise().then(flowResult => {
                // save flowName to deployItem
                //debugger
                this.results.push(`updated Flow "${destinationFlow.displayName}" (${destinationFlow.flowName}).  state: ${state}.`);
              }, (reason)=> {
                this.results.push(`update Flow failed "${destinationFlow.displayName}" (${destinationFlow.flowName}).  reason: ${JSON.stringify(reason.error)}.`);

              });

            });
            return p1;
          }
        });
        promises.push(p);
      }
      if (sourceFlow.type == "powerapp") {
        let p = this.flowManagementService.getApp(this.deployPlan.environmentSource, sourceFlow.flowName).then(app => {

          let replacements = item.replacements.filter(r=>{
            return (
                r.type == 'DisplayName' ||
                r.type == 'State' ||
                (r.source && r.source != r.destination)
              );
          });

          let connectionReferences = app.properties.connectionReferences;

          let keys = Object.keys(connectionReferences);
          keys.forEach(ref=>{

            let conRef = connectionReferences[ref];

            // for each connection ref.  look for connection string replacement.
            let rule = replacements.find(r=>r.type=="Connection" && r.source == conRef.connectionName);
            if (rule) {

              // in PowerApps - the ConRef 'ref' id needs to be replaced
              // find connection in destination connection first
              // use that 'ref' in app.properties.connectionReferences

              if (rule.source == conRef.connectionName) {

                let destination = this.destinationConnections.find(c=>c.name == rule.destination);

                // debugger;

                // if (destination != null) {
                //   connectionReferences[ref] = {
                //     'connectionName': rule.destination,
                //     'id': `${destination.apiId}`
                //   }

                // }
                // else {
                //   connectionReferences[ref] = {
                //     'connectionName': rule.destination,
                //     'id': `${connectionReferences[ref].id}`
                //   }
                // }

              }
            }
          });


          this.results.push(`migrate PowerApp skipped "${sourceFlow.displayName}".  reason: stay tuned.`);
          //return this.flowManagementService.putApp(app);

        })
        p.catch((reason)=>{
          this.results.push(`update PowerApp failed "${destinationFlow.displayName}" (${destinationFlow.name}).  reason: ${JSON.stringify(reason.error)}.`);
        })
        promises.push(p);
      }

    })

    Promise.all(promises).then(()=>{

      this.results.push(`finished... "${this.deployPlan.name}".`);
      // save changes to plan
      return this.savePlans().then(()=>{
        // refresh
        if (needPostRefresh) {
          this.results.push(`refreshing deployed flows...`)
          this.refresh(false, true).then(()=>{
            //this.results.push(`done.`)
          });

        }
      })
    });

    // let flowSource = this.source;

    // let destination = 'f5391653-1ee6-450c-9d05-3a0485a829f1';

    // this.flowManagementService.createSolutionFlow(this.flowManagementService.currentEnvironment, 'beb22393-dc66-e911-a97e-000d3ad1c0d2', this.raw).toPromise().then(response=>{

    //   let r = response;
    //   debugger;
    // });


  }

  // public onStateChange(state: State) {
  //   this.gridState = state;

  //   this.editService.read();
  // }

  public cellClickHandler({ sender, rowIndex, columnIndex, dataItem, isEdited }) {

      // if (columnIndex != 3) {
      //   return;
      // }

      if (!isEdited) {
          sender.editCell(rowIndex, columnIndex, this.createFormGroup(dataItem));
      }
  }

  public rcellClickHandler({ sender, rowIndex, columnIndex, dataItem, isEdited }) {

    if (/*columnIndex == 2 ||*/ columnIndex >= 3) {
      // ok
    } else if (columnIndex == 2 && !dataItem.name && dataItem.type == 'Text') {
      // ok
    }
    else {
      return;
    }

    if (dataItem.type == 'Connection') {

      let connections = this.destinationConnections.filter(c=>{
        let id = (dataItem.path || []).join('');
        return (c.apiId  == id || c.apiId  == `/providers/Microsoft.PowerApps/apis/${dataItem.name}`);
      });

      if (connections.length > 0) {
        this.viewDestinationConnections = connections;
      }
      else {
        this.viewDestinationConnections = this.destinationConnections;
      }

    }

    if (dataItem.type == 'Text' && dataItem.name == 'URL') {

      this.viewURLs = this.destinationObjects.filter(f=>{
        return f['triggerKind'] == "Http";
      }).map( (f:Flow)=>{
        return {
          'displayName': f.displayName,
          'triggerIcon': f.triggerIcon,
          'triggerKind': f.triggerKind,
          'triggerUrl': f.triggerUrl
        };
      })
    }

    if (!isEdited) {
        sender.editCell(rowIndex, columnIndex, this.createRFormGroup(dataItem));
    }
}

  public cellCloseHandler(args: any) {
      const { formGroup, dataItem } = args;

      if (!formGroup.valid) {
          // prevent closing the edited cell if there are invalid values.
          args.preventDefault();
      } else if (formGroup.dirty) {
          Object.assign(dataItem, formGroup.value);
          // this.editService.assignValues(dataItem, formGroup.value);
          // this.editService.update(dataItem);
      }
  }

  public rcellCloseHandler(args: any) {
    const { formGroup, dataItem } = args;

    if (!formGroup.valid) {
        // prevent closing the edited cell if there are invalid values.
        args.preventDefault();
    } else if (formGroup.dirty) {

        Object.assign(dataItem, formGroup.value);
        // this.editService.assignValues(dataItem, formGroup.value);
        // this.editService.update(dataItem);
    }
  }

  public addHandler({ sender }) {
      sender.addRow(this.createFormGroup(new DeployItem()));
  }

  public raddHandler({ sender }) {
    sender.addRow(this.createRFormGroup(Object.assign(new DeployReplaceItem(), {'type': 'Text'})));
}

  public cancelHandler({ sender, rowIndex }) {
      sender.closeRow(rowIndex);
  }

  public saveHandler({ sender, formGroup, rowIndex }) {
      if (formGroup.valid) {
          // this.editService.create(formGroup.value);
          let item : DeployItem = Object.assign(new DeployItem(), formGroup.value);

          this.wizard(item);

          // item._flowSource = this.source.find(f=>f.flowName == item.flowSource);
          // item._flowDestination = this.source.find(f=>f.flowName == item.flowDestination);

          this.deployPlan.items.push( item );
          sender.closeRow(rowIndex);
      }
  }

  public rsaveHandler({ sender, formGroup, rowIndex }, parentItem: DeployItem) {
    if (formGroup.valid) {
        // this.editService.create(formGroup.value);

        let item : DeployReplaceItem = rowIndex == -1 ?  new DeployReplaceItem() : parentItem.replacements[rowIndex];

        Object.assign(item, formGroup.value);

        // item._flowSource = this.source.find(f=>f.flowName == item.flowSource);
        // item._flowDestination = this.source.find(f=>f.flowName == item.flowDestination);

        if (rowIndex == -1) {
          parentItem.replacements.push( item);
        }
        sender.closeRow(rowIndex);
    }
  }

  /**
   * Decide whether the cached flows for an environment are still fresh enough
   * to skip a network scan. Mirrors the staleness rule used by /flows so the
   * deploy page benefits from any prior scan within the same window.
   * Falls back to a network fetch when the env has no recorded scan.
   */
  private async getFlowsRespectingScanStale(env: string): Promise<Flow[]> {
    const stored = await this.storageDexieService.getEnvironment(env).catch(() => null);
    const setting = await this.storageDexieService.getConfig(Settings.SETTING_AUTO_REFRESH_HOURS).catch(() => null);
    const hours = Number(setting?.value);
    const staleMs = Number.isFinite(hours)
      ? Math.max(ENV_SCAN_STALE_MS, hours * 60 * 60 * 1000)
      : ENV_SCAN_STALE_MS;
    const scannedAt = stored?.scanCompletedAt ?? null;
    const isFresh = scannedAt != null && (Date.now() - scannedAt) < staleMs;

    if (isFresh) {
      // Reuse the cached flows for this env — no network round-trip.
      const all = await this.storageDexieService.getFlows();
      return all.filter((f) => f.environment === env);
    }
    // Stale or never-scanned — do a real fetch (and let it write back to cache).
    return this.flowManagementService.getFlows(env, false, false, false, false);
  }

  public doDiff(item) {
    // Get the current row's source vs destination flow and navigate to the
    // diff route. Both sides default to the current version.
    if (!item?.flowSource || !item?.flowDestination) return;
    this.router.navigate([
      '/flows',
      this.deployPlan.environmentSource,
      item.flowSource,
      'current',
      'diff',
      this.deployPlan.environmentDestination,
      item.flowDestination,
      'current',
    ]);
  }

  public getFlow(name: string) : PowerBase {
    return this.sourceObjects.find(f=>f.name == name);
  }

  public getDestinationFlow(name: string) : PowerBase {
    return this.destinationObjects.find(f=>f.name == name);
  }

  public getSourceConnection(name: string) {
    return this.sourceConnections.find(c=>c.name == name);
  }

  public getConnection(name: string) {
    return this.destinationConnections.find(c=>c.name == name);
  }

  public removeHandler({ sender, dataItem }) {
      // this.editService.remove(dataItem);
      this.deployPlan.items = this.deployPlan.items.filter(p => p != dataItem);

      sender.cancelCell();
  }

  public rremoveHandler({ sender, dataItem }, parentItem: DeployItem) {
    // this.editService.remove(dataItem);
    let removeItem = sender.activeRow.dataItem;

    parentItem.replacements = parentItem.replacements.filter(p => p != removeItem);
    sender.cancelCell();
  }

  public hasChanges(): boolean {
    return true;
  }

  public savePlans(force=false): Promise<any> {
      if (!this.deployPlan.name) {
        this.deployPlan.name = this.selectedPlan;
      }

      if (!this.deployPlan.name && force==false) {
        //this.tooltipDir.show(this.selectedPlanAnchor['wrapper']);
        //alert('Give the plan a new name...')
        return Promise.resolve([]);
      }

      if (this.deployPlan.name != this.selectedPlan && this.selectedPlan) {
        this.plans.push(Object.assign({}, this.deployPlan, {name: this.selectedPlan}));
      }

      this.loading = true;

      let pause = new Promise((resolve) => { setTimeout(resolve, 1000) });

      if (this.plans.filter(p=>p.name == this.deployPlan.name).length == 0) {
        this.plans.push(this.deployPlan);
      }

      let pSave = pause.then(()=>{
      //   return this.storageDexieService.updatePlans(this.plans);
      // }).then(()=>{
        return this.flowManagementService.updatePlans(this.plans);
      }).then(()=>{
        this.loading = false;
      });
      return pSave;
  }

  public editPlanJson() {
    // Save first so the route page reads the latest plans, then navigate.
    this.savePlans().then(() => {
      this.router.navigate(['/migrate/plan']);
    });
  }

  public editSelectedPlanJson() {
    // Single-plan editor keyed by plan.name. Saving first ensures the route
    // page picks up any in-flight edits the user made on /migrate.
    this.savePlans().then(() => {
      const id = this.deployPlan?.name;
      if (!id) return;
      this.router.navigate(['/migrate/plan', id]);
    });
  }

  public saveChanges(grid: any): void {
      grid.closeCell();
      grid.cancelCell();

      this.savePlans();
      // this.editService.saveChanges();
  }

  public cancelChanges(grid: any): void {
      grid.cancelCell();

      // this.editService.cancelChanges();
  }

  public createFormGroup(dataItem: any): UntypedFormGroup {
      return this.formBuilder.group({
          'flowSource': dataItem.flowSource,
          'flowDestination': dataItem.flowDestination
      });
  }

  public createRFormGroup(dataItem: any): UntypedFormGroup {
    return this.formBuilder.group({
        'type': dataItem.type,
        'name': dataItem.name,
        'source': dataItem.source,
        'destination': dataItem.destination,
        'description': null
    });
  }

  public ignore(item, grid) {
    item.ignore = true;
  }

}
